import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import FilterBar from '../FilterBar';
import SearchContent from '../SearchContent';
import MapSection from '../MapSection';
import PanelSmallScreen from '../FilterBar/PanelSmallScreen';

import styles from '../styles.js';

import { uiActions } from '../../actions';

import { getActiveFilterCount, isAllDaySelected } from '../../selectors';

class Vertical extends Component {
    static propTypes = {
        activeVerticalId: PropTypes.number.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        fullScreenPanel: PropTypes.object.isRequired,
        getActiveFilters: PropTypes.number.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        toggleFullScreenPanel: PropTypes.func.isRequired,
        toggleMapPanel: PropTypes.func.isRequired,
        user: PropTypes.object,
        verticals: PropTypes.array.isRequired
    }

    render() {
        const {
            activeVerticalId,
            contentLoading,
            fullScreenPanel,
            getActiveFilters,
            initialContentLoaded,
            toggleFullScreenPanel,
            toggleMapPanel,
            user,
            verticals
        } = this.props;
        const filterGroupCollections = verticals.find(
            vertical => vertical.id === activeVerticalId
        ).filterGroupCollections;
        return (
            <main className={css(styles.main)}>
                <div className={css(styles.mapSearch)}>
                    <FilterBar
                        filterGroupCollections={filterGroupCollections}
                        getActiveFilters={getActiveFilters}
                        toggleFullScreenPanel={toggleFullScreenPanel}
                        toggleMapPanel={toggleMapPanel}
                    />
                    <div className={css(styles.mainContentWrapper)}>
                        <SearchContent
                            contentLoading={contentLoading}
                            filterGroupCollections={filterGroupCollections}
                            getActiveFilters={getActiveFilters}
                            initialContentLoaded={initialContentLoaded}
                            toggleFullScreenPanel={toggleFullScreenPanel}
                            user={user}
                        />
                    </div>
                    {
                        initialContentLoaded ?
                            <MapSection /> : null
                    }
                    {
                        fullScreenPanel.isVisible ?
                            <PanelSmallScreen
                                filterGroupCollections={filterGroupCollections}
                                toggleFullScreenPanel={toggleFullScreenPanel}
                            /> : null
                    }
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => ({
    activeVerticalId: state.activeVerticalId,
    allDaySelected: isAllDaySelected(state),
    contentLoading: state.contentLoading,
    fullScreenPanel: state.fullScreenPanel,
    getActiveFilters: getActiveFilterCount(state),
    initialContentLoaded: state.initialContentLoaded,
    user: state.user,
    verticals: state.verticals
});

const mapDispatchToProps = dispatch => {
    return {
        toggleFullScreenPanel: () => {
            dispatch(uiActions.toggleFullScreenPanel());
        },
        toggleMapPanel: () => {
            dispatch(uiActions.toggleMapPanel());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Vertical);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/Vertical/Vertical.jsx